  export const createEntry = (data) => {
  return (dispatch, getState, { getFirebase }) => {
    return getFirebase()
      .ref("blog_entries")
      .push(data)
      .then(() => dispatch({ type: "CREATE_ENTRY" }))
      .catch((err) => dispatch({ type: "CREATE_ENTRY_ERR", err }));
  };
};

export const updateEntry = (data, key) => {
  return (dispatch, getState, { getFirebase }) => {
    return getFirebase()
      .ref(`blog_entries/${key}`)
      .update(data)
      .then(() => dispatch({ type: "UPDATE_ENTRY" }))
      .catch((err) => dispatch({ type: "UPDATE_ENTRY_ERR", err }));
  };
};

export const deleteEntry = (key) => {
  return (dispatch, getState, { getFirebase }) => {
    return getFirebase()
      .ref(`blog_entries/${key}`)
      .remove()
      .then(() => dispatch({ type: "DELETE_ENTRY" }))
      .catch((err) => dispatch({ type: "DELETE_ENTRY_ERR", err }));
  };
};
